import React, { useState, useContext } from "react";

import DaysBar from "../DaysBar.jsx";
import Items from "../Items.jsx";
import OrderDetails from "../OrderDetails.jsx";

import { ContextProvider } from "../../../App";

function MonthlyMenu({ selectionPlan,mondayItem, setMondayItem,tuesItem, setTuesItem,wednesdayItem, setWednesdayItem,thursdayItem, setThursdayItem,fridayItem, setFridayItem }) {
  const { cartState, cartDispatch, authState } = useContext(ContextProvider);

  const [foodItems, setFoodItems] = useState(authState.categories);

  const [barHeight, setBarHeight] = useState(7);
  const [dayItem, setDayItems] = useState("Monday");

  const [title, setTitle] = useState("");


  const handleDaysBarHeight = (day) => {
    setDayItems(day);
    cartDispatch({ type: "DAYS", dayItem: day });
    
    if (day === "Monday") {
      setBarHeight(7);
    } else if (day === "Tuesday") {
      setFoodItems(authState.categories);
      setBarHeight(14);
    } else if (day === "Wednesday") {
      setBarHeight(21);
      setFoodItems(authState.categories);
    } else if (day === "Thursday") {
      setBarHeight(28);
      setFoodItems(authState.categories);
    } else if (day === "Friday") {
      setBarHeight(36);
      setFoodItems(authState.categories);
    } else {
      setBarHeight(7);
    }
  };

  const selectFoodCategory = (id, title) => {

    cartDispatch({ type: "SELECT_FOOD_ITEM", id, dayItem, title });

    const selectedItem = foodItems.filter((item) => item._id === id);

    if (dayItem === "Monday") {
      setMondayItem(selectedItem);
      setTitle(title)
    } else if (dayItem === "Tuesday") {
      setTuesItem(selectedItem);
      setTitle(title)
    } else if (dayItem === "Wednesday") {
      setWednesdayItem(selectedItem);
      setTitle(title)
    } else if (dayItem === "Thursday") {
      setThursdayItem(selectedItem);
      setTitle(title)
    } else if (dayItem === "Friday") {
      setFridayItem(selectedItem);
      setTitle(title)
    } else {
      setFoodItems(foodItems);
    }
  };

  return (
    <>
      <div className="select_main_container">
        <div className="select_content_container">
          <div className="dayBox1">
            <DaysBar
              handleDaysBarHeight={handleDaysBarHeight}
              barHeight={barHeight}
              foodItems={foodItems}
              dayItem={dayItem}
            />
          </div>
          <div className="itemBox2">
            <Items
              foodItems={foodItems}
              setDayItems={setDayItems}
              selectFoodCategory={selectFoodCategory}
              dayItem={dayItem}
              mondayItem={mondayItem}
              setMondayItem={setMondayItem}
              tuesItem={tuesItem}
              wednesdayItem={wednesdayItem}
              thursdayItem={thursdayItem}
              fridayItems={fridayItem}
            />
          </div>
          <div className="detailsBox3">
            <OrderDetails title={ title} cartState={cartState} selectionPlan={selectionPlan} />
          </div>
        </div>
      </div>
    </>
  );
}

export default MonthlyMenu;
